export default "__VITE_ASSET__D4b834t3__"